export enum USER_COUNT {
  MIN = 0,
  MAX = 200,
}

export enum TRANSACTION_VALUE {
  MIN = 4000,
  MAX = 20000,
}

export enum PROFILE_TABS {
  PERSONAL,
  PROGRAM,
  PAYMENT,
}

export enum HEADER_TYPE {
  AT_REGISTRATION = 'AT_REGISTRATION',
  BEFORE_REGISTRATION = 'BEFORE_REGISTRATION',
  AFTER_REGISTRATION = 'AFTER_REGISTRATION',
}

export enum FORM_INPUT_TYPE {
  FIRST_NAME = 'First Name',
  LAST_NAME = 'Last Name',
  MOBILE_NUMBER = 'Mobile Number',
  ENTER_OTP_M = 'Enter OTP',
  EMAIL_ADDRESS = 'Email Address',
  ENTER_OTP_E = 'Enter OTP',
  STATE = 'State',
  CITY = 'City',
  REFERRAL_CODE = 'Referral Code',
  VP_CENTER = 'Vidyapeeth Center',
}

export enum testType {
  WHATSAPP = 'whatsapp',
  RESEND = 'resend',
}

export enum PAYMENT_FIELDS {
  BANK_ACCOUNT_NUMBER = 'bankAccountNumber',
  BANK_HOLDER_NAME = 'bankHolderName',
  BANK_NAME = 'bankName',
  IFSC_CODE = 'ifscCode',
  BANK_BRANCH = 'bankBranch',
  PAN_CARD_NUMBER = 'panCardNumber',
  PASSBOOK = 'passbookFirstPage',
  GST_CERTIFICATE = 'gstCertificate',
  PAN_CARD = 'panCard',
  PASSPORT = 'passportPhoto',
  MSME_CERTIFICATE = 'msmeCertificate',
  MSME_REG_NO = 'msmeRegNo',
  SELF_DECLARATION = 'selfDeclaration',
  ADDRESS = 'addressLine',
  CITY = 'city',
  STATE = 'state',
  PINCODE = 'pincode',
  HOUSE_ADDRESS = 'houseAddress',
}

export enum NOTIFICATION_TYPE {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export enum LOCATED_FROM {
  REGISTRATION = 'Registration',
  STATISTICS = 'Statistics',
}

export enum PROFILE_STAGE {
  PAYMENT = 'PAYMENT_DETAILS',
  SELECTION = 'PROGRAM_SELECTION',
  PERSONAL = 'PERSONAL_DETAILS',
  PROGRAM_DETAILS = 'PROGRAM_DETAILS',
  SAATHI_PROGRAM = 'SAATHI_PROGRAM',
}
export enum PROGRAM_TYPE {
  CAMPUS_NON_MEDED = 'CAMPUS_PROGRAM',
  CAMPUS_MEDED = 'CAMPUS_PROGRAM_MEDED',
  INFLUENCER = 'AFFILIATE_INFLUENCE_PROGRAM',
  AFFILIATE = 'AFFILIATE_PROGRAM',
  SAATHI = 'SAATHI',
  CSC_PROGRAM = 'CSC_PROGRAM',
}

export enum CAMPUS_PROGRAM_TYPE {
  COLLEGE = 'COLLEGE_PROGRAM',
  SCHOOL = 'SCHOOL_PROGRAM',
}

export enum TYPE_OTHERS {
  OTHERS = 'OTHERS',
}

export enum SELECTED_PROGRAM_INDEX {
  PERSONAL_DETAILS = 'personalDetails',
  PROGRAM_SELECTION = 'programSelection',
  PROGRAM_DETAILS = 'programDetails',
  SAATHI = 'saathi',
}

export enum OTP_FROM {
  Get_OTP = 'Get OTP',
  OTP_Sent = 'OTP Sent',
  RESEND_OTP = 'Resend OTP',
  CONTINUE = 'Continue',
  Enter = 'Enter',
  LET_GO = `Let's Go!`,
}

export enum COLLEGE_IFORM {
  COURSE_NAME = 'courseName',
  COLLEGE_NAME = 'collegeName',
  COLLEGE_EMAILID = 'collegeEmailId',
  GRADUATION_YEAR = 'graduationYear',
  COLLEGE_IDCARD = 'collegeIdCard',
  INSERT_OTHER_COLLEGE = 'insertOtherCollege',
  INSERT_OTHER_COURSE = 'insertOtherCourse',
  COLLEGE_TYPE = 'collegeType',
  COURSE_TYPE = 'courseType',
  IS_DROPDOWN_COLLAGE = 'isDropdownCollage',
  IS_DROPDOWN_COURSE = 'isDropdownCourse',
  IS_DROPDOWN_YEAR = 'isDropdownYear',
  PROGRAM_TYPE = 'programType',
  PROFILE_STAGE = 'profileStage',
  CAMPUS_PROGRAM_TYPE = 'campusProgramType',
}

export enum TITLE_FOR {
  FULL_NAME = 'fullName',
  PHONE_NUMBER = 'phoneNumber',
}

export enum AMBASSADOR_NAMES {
  CAMPUS_AMBASSADOR = 'Campus Ambassador',
  AFFILIATE_AMBASSADOR = 'Affiliate Ambassador',
}
export enum NEW_PROGRAM_PROFILE {
  DEFAULT_DATA = 'default_data',
  STUDENT = 'student',
  BUSINESS = 'business',
  PROFESSIONAL = 'professional',
  SCHOOL = 'school',
  COLLEGE = 'college',
  MEDICAL = 'medical',
  ENGINEERING = 'engineering',
  OTHER_FIELDS = 'otherFields',
  UNDER_GRADUATE = 'undergraduate',
  POST_GRADUATE = 'postgraduate',
  ADVAN_MEDICAL = 'advan_medical',
  OTHER_COURSES = 'other_courses',
  SHOP_BUSINESS = 'shop_business',
  DIFF_BUSINESS = 'diff_business',
}

export enum FORM_NAME_TYPE {
  SCHOOL = 'School',
  COLLEGE = 'College',
  SHOP = 'Shop',
  MSME = 'MSME Certificate',
  Declaration = 'Upload Self Declaration',
}

export enum LIVE_CATEGORY_NAME {
  NORMAL = 'NORMAL',
  OFFLINE = 'OFFLINE',
  VP_LIVE = 'VP_LIVE',
  Online_Courses = 'Online Courses',
  Offline_Batch = 'Offline Batch',
  Power_Batch = 'Power Batch',
  Hybrid_Coaching = '(Hybrid_Coaching)',
  VP_PS = '(Vidyapeeth & Pathshala)',
}

export enum LOCATION_PROPERTIES {
  GRANTED = 'granted',
  PROMPT = 'prompt',
  GEOLOCATION = 'geolocation',
}

export enum SUPER_MODAL_ENUM {
  NONE = "NONE",
  PURCHASE_ACTION_MODAL = "PURCHASE_ACTION_MODAL",
  LOCK_MODAL = "LOCK_MODAL",
  BATCH_ACTIVATION_MODAL = "BATCH_ACTIVATION_MODAL",
  ACCESS_PENDING_CARD = "ACCESS_PENDING_CARD",
  EMI_REMINDER_MODAL = "EMI_REMINDER_MODAL",
  CALL_SUPPORT_MODAL = "CALL_SUPPORT_MODAL",
  MAHAPACK_MODAL = "MAHAPACK_MODAL",
  COMPARISION_TABLE = "COMPARISION_TABLE",
  PREMIUM_BATCH_CHANGE_MODAL = "PREMIUM_BATCH_CHANGE_MODAL",
  FAQ_VIDEO_MODAL = "FAQ_VIDEO_MODAL",
  VIDEO_PLAYER_MODAL = "VIDEO_PLAYER_MODAL",
  AI_PERSONALISATION_MODAL = "AI_PERSONALISATION_MODAL",
  ENROLL_DEPP_LINK_MODAL = "ENROLL_DEPP_LINK_MODAL",
  VERNACULAR_MODAL = "VERNACULAR_MODAL",
  ATTACHMENT_MODAL = "ATTACHMENT_MODAL",
}

export enum SUPER_SLIDEOVER_ENUM {
  NONE = "NONE",
  EMI_BREAKUP_TABLE_COMPONENT = "EMI_BREAKUP_TABLE_COMPONENT",
  PREMIUM_BATCH_CHANGE_MODAL = "PREMIUM_BATCH_CHANGE_MODAL",
  USER_ADDRESS_FORM = "USER_ADDRESS_FORM",
}

export enum PaymentStatus {
  SUCCESS = 'success',
  PENDING = 'pending',
  FAILED = 'failed',
  ERROR = 'error',
}
export enum StatusEnum {
  CONVERTED = 'CONVERTED',
  IN_PROGRESS = 'IN_PROGRESS',
  DROPPED = 'DROPPED',
}

export enum LEADS_STATUS {
  ACCEPTED_LEADS = 'Accepted Leads',
  CONVERTED_LEADS = 'Converted Leads',
  LEADS_IN_PROGRESS = 'Leads In Progress',
}

export enum SAATHI_COMMISSION_HEADER {
  ADMISSIONS_DAY = 'Admissions/day',
  Class_8_10 = 'Commission for Class 8-10',
  CLASS_11_12 = 'Commission for Class 11-12+'
}

export enum SAATHI_COMMISSION_CLASS {
  class_6_10 = '6-10',
  class_11 = '11+',
  class_1_5 = '1-5'
}

export enum ApplicationTypes {
  PW_CENTRES = 'PW_CENTRES',
  PW_SPD = 'PW_SPD',
  PW_MICRO_LEARNING = 'PW_MICRO_LEARNING',
  PAYMENT_FE = 'PAYMENT_FE',
  BATCH_PLUS_TABLE = 'BATCH_PLUS_TABLE',
  PAYMENT_MF = 'PAYMENT_MF',
}